import React, { useState } from 'react';

const ClientFeedbackSection = () => {
  const [currentSlide, setCurrentSlide] = useState(1); // Empezar en el slide del medio

  const testimonials = [
    {
      id: 1,
      name: "John Smith",
      text: "I've been with Azucarai for over three years they have handled all aspects of my advertising and hands-down are the very best my representative Miss Jacqueline Castillo always goes over and above all my expectations. Very professional and courteous.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face"
    },
    {
      id: 2,
      name: "Chandra Dewaon",
      text: "I had several issues with my account after talking to the manager and he handled everything like a Business that is representing their client should have done thank you Azucarai.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=100&h=100&fit=crop&crop=face"
    },
    {
      id: 3,
      name: "Kelly Nadler",
      text: "Excellent customer service was provided by Jackie! She was very easy to work with, answered all my questions, and made suggestions to save me hundreds of $$% in fees. Thanks so much. We will continue to use your services now and in the future",
      avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-blue-400 text-sm font-semibold uppercase tracking-wide mb-2">
            TESTIMONIALS
          </p>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800">
            Client Feedback & Reviews
          </h2>
        </div>

        {/* Carousel de testimonios */}
        <div className="relative max-w-4xl mx-auto px-8 sm:px-0">
          {/* Contenedor de testimonios */}
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial) => (
                <div key={testimonial.id} className="w-full flex-shrink-0">
                  <div className="bg-white border border-blue-200 rounded-lg p-8 text-center max-w-lg mx-auto">
                    {/* Avatar */}
                    <div className="mb-6">
                      <img
                        src={testimonial.avatar}
                        alt={testimonial.name}
                        className="w-20 h-20 rounded-full mx-auto object-cover border border-blue-200"
                      />
                    </div>

                    {/* Testimonial text con comillas grandes */}
                    <div className="relative mb-6">
                      <div className="text-6xl text-blue-200 font-bold absolute -top-4 -left-2">"</div>
                      <p className="text-gray-600 text-base leading-relaxed italic relative z-10 px-4">
                        {testimonial.text}
                      </p>
                      <div className="text-6xl text-blue-200 font-bold absolute -bottom-4 -right-2">"</div>
                    </div>

                    {/* Customer name */}
                    <p className="text-gray-800 font-bold text-lg">
                      {testimonial.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Botones de navegación */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-2 sm:-translate-x-6 w-10 h-10 sm:w-12 sm:h-12 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow-lg hover:bg-gray-50 transition-colors"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-2 sm:translate-x-6 w-10 h-10 sm:w-12 sm:h-12 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow-lg hover:bg-gray-50 transition-colors"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        {/* Dots de navegación */}
        <div className="flex justify-center space-x-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-colors ${
                index === currentSlide ? 'bg-gray-800' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientFeedbackSection;
